import { AsyncThunkAction, SerializedError } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import { HttpStatusCode } from 'axios';

import { AppDispatch, AppState } from 'app/redux/types/types';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { NavigationService } from 'app/services/navigation-service';

export const useDispatchRequestAndHandleErrors = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return (actionToDispatch: AsyncThunkAction<unknown, unknown, { dispatch: AppDispatch; state: AppState }>) => {
        dispatch(actionToDispatch)
            .unwrap()
            .catch((error: SerializedError) => {
                if (error.code === HttpStatusCode.Unauthorized.toString()) {
                    return navigate(NavigationService.ERROR_SESSION_EXPIRED, { replace: true });
                }

                return navigate(NavigationService.ERROR, { replace: true });
            });
    };
};
